import React, {useContext} from 'react';
import './PickupCaption.less';
import {ScheduleCaption} from 'elements/schedule-caption/ScheduleCaption';
import PickupIcon from 'new-images/pickup.svg';
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";

export const PickupCaption = ({time}) => {
	const translations = useContext(TranslationsContext);

	return <ScheduleCaption text={getSafeTranslation('PickupCaption.timeTemplate', translations).replace('{time}', time)}
													icon={PickupIcon}/>;
};
